var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-content-container",class:[
    _vm.sourceClass,
    {
      active: _vm.isActive,
      empty: !_vm.hasValue,
      required: _vm.isRequired,
      checkbox: _vm.checkbox,
      invalid: _vm.invalid,
      warning: !_vm.hasValidatedValue,
    } ]},[_c('span',{class:[
      'field-content-text',
      { 'scale-initials': _vm.scaleInitials, 'show-initials': _vm.showInitials } ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }